import {
   SET_FLOW_EXECUTION_FAILED,
   SET_FLOW_EXECUTION_FAILED_RESET,
   ADD_EXECUTION_REPORT,
   SHOW_FLOW_USAGE_DIALOG,
   HIDE_FLOW_USAGE_DIALOG,
   SET_EXECUTION_LOGS,
   SET_EXECUTION_BATCH_DATE_TIME,
   CLEAR_EXECUTION_BATCH_DATE_TIME,
   ADD_STEP_INFO,
   SET_REPORT_TYPE,
   SHOW_CALENDAR_DIALOG,
   HIDE_CALENDAR_DIALOG,
   SET_SELECTED_LOG_NODE_ID,
   CLEAR_SELECTED_LOG_NODE_ID,
   CLEAR_FLOW_EXECUTION_REPORTS,
   SET_CURRENT_EXECUTION_REPORT_SESSION_ID,
   END_EXECUTION_REPORT,
   ADD_REPORT_STATE,
   RESET_EXECUTION_REPORTS,
   SET_EXECUTOR_SOCKET_DOWN
} from "redux/constants/flowDesigner";
import { REPORT_TYPES } from "constants/flowDesigner";
import { calculateTotalDuration } from "helpers/common";

const initialState = {
   executionReports: [],
   flowUsageDialog: {
      open: false,
      message: ""
   },
   flowExecutionFailed: false,
   executionLogs: [],
   executionBatchDateTime: "",
   tempSteps: [],
   reportType: REPORT_TYPES.TIMELINE,
   showCalendarDialog: false,
   selectedLogNodeId: null,
   flowReports: {},
   isExecutorSocketDown: false
};

const MAX_NUM_REPORTS = 25;

const flowExecution = (state = initialState, { type, payload }) => {
   let reports;

   switch (type) {
      case SET_FLOW_EXECUTION_FAILED:
         return {
            ...state,
            flowExecutionFailed: true
         };
      case SET_FLOW_EXECUTION_FAILED_RESET:
         return {
            ...state,
            flowExecutionFailed: false
         };
      case ADD_EXECUTION_REPORT: {
         const tempSteps = [...state.tempSteps];
         const steps = tempSteps.filter((s) => s.execution_batch_datetime === payload.time);

         const newPayload = {
            ...payload,
            data: steps.length > 0 ? steps : payload.data ? [...payload.data] : []
         };

         const flowReport = state.flowReports[newPayload.id];

         return {
            ...state,
            executionReports: [...state.executionReports, newPayload],
            tempSteps: tempSteps.filter((s) => s.execution_batch_datetime !== payload.time),
            flowReports: {
               ...state.flowReports,
               [newPayload.id]: {
                  reports: [
                     ...(flowReport ? flowReport.reports : []),
                     {
                        type: "reportSession",
                        payload: { ...newPayload, data: [...newPayload.data] }
                     },
                     ...steps.map((step) => ({
                        type: "reportData",
                        payload: step
                     }))
                  ]
               }
            }
         };
      }

      case SHOW_FLOW_USAGE_DIALOG:
         return {
            ...state,
            flowUsageDialog: { open: true, message: payload }
         };
      case HIDE_FLOW_USAGE_DIALOG:
         return {
            ...state,
            flowUsageDialog: { open: false, message: "" }
         };
      case SET_EXECUTION_LOGS:
         return {
            ...state,
            executionLogs: payload
         };
      case SET_EXECUTION_BATCH_DATE_TIME:
         return {
            ...state,
            executionBatchDateTime: payload
         };
      case CLEAR_EXECUTION_BATCH_DATE_TIME:
         return {
            ...state,
            executionBatchDateTime: ""
         };
      case ADD_STEP_INFO: {
         reports = [...state.executionReports]; 
         const report = reports.find((r) => r.time === payload.execution_batch_datetime);

         if (report?.data?.length === 0) {
            payload.isFirst = true;
         }

         if (report) {
            report.data = [...report.data, payload];
         } else {
            return {
               ...state,
               tempSteps: [...state.tempSteps, payload]
            };
         }

         if (reports.length > MAX_NUM_REPORTS)
            reports.splice(0, reports.length - MAX_NUM_REPORTS);
 
         const flowReport = state.flowReports[payload.flowId];

         if (!flowReport) {
            return {
               ...state,
               executionReports: reports
            };
         }

         if (payload.isCustomLog) {
            const updatedReports = [...flowReport.reports];

            const sessionEndIndex = updatedReports.findIndex((report) => report.type === "sessionEnd" && report.payload.sessionId === payload.sessionId);

            const newReportItem = {
               type: "reportData",
               payload
            };

            if (sessionEndIndex !== -1) {
               updatedReports.splice(sessionEndIndex, 0, newReportItem);

               const flowReportItems = updatedReports.filter((report) => report.type === "reportData" && report.payload.sessionId === payload.sessionId);

               updatedReports[sessionEndIndex + 1] = {
                  ...updatedReports[sessionEndIndex + 1],
                  payload: {
                     ...updatedReports[sessionEndIndex + 1].payload,
                     totalDuration: calculateTotalDuration(flowReportItems.map((report) => report.payload)),
                     totalNodes: new Set(flowReportItems.map((report) => report.payload.componentKey)).size
                  }
               };
            } else {
               updatedReports.push(newReportItem);
            }

            return {
               ...state,
               executionReports: reports,
               flowReports: {
                  ...state.flowReports,
                  [payload.flowId]: {
                     ...flowReport,
                     reports: updatedReports
                  }
               }
            };
         }

         return {
            ...state,
            executionReports: reports,
            flowReports: {
               ...state.flowReports,
               [payload.flowId]: {
                  ...flowReport,
                  reports: [
                     ...flowReport.reports,
                     {
                        type: "reportData",
                        payload
                     }
                  ]
               }
            }
         };
      }
      case SET_REPORT_TYPE:
         return {
            ...state,
            reportType: payload
         };
      case SHOW_CALENDAR_DIALOG:
         return {
            ...state,
            showCalendarDialog: true
         };
      case HIDE_CALENDAR_DIALOG:
         return {
            ...state,
            showCalendarDialog: false
         };
      case SET_SELECTED_LOG_NODE_ID:
         return {
            ...state,
            selectedLogNodeId: payload
         };
      case CLEAR_SELECTED_LOG_NODE_ID:
         return {
            ...state,
            selectedLogNodeId: null
         };
      case CLEAR_FLOW_EXECUTION_REPORTS: {
         const flowReports = { ...state.flowReports };

         delete flowReports[payload];

         return {
            ...state,
            executionReports: state.executionReports.filter((r) => r.id !== payload),
            flowReports
         };
      }
      case SET_CURRENT_EXECUTION_REPORT_SESSION_ID:
         return {
            ...state,
            currentExecutionReportSessionId: payload
         };
      case END_EXECUTION_REPORT: {
         const flowReport = state.flowReports[payload.flowId];

         if (!flowReport) return state;

         const flowReportItems = flowReport.reports.filter((report) => report.type === "reportData" && report.payload.sessionId === payload.sessionId);

         return {
            ...state,

            flowReports: {
               ...state.flowReports,
               [payload.flowId]: {
                  ...flowReport,
                  reports: [
                     ...flowReport.reports,
                     {
                        type: "sessionEnd",
                        payload: {
                           ...payload,
                           totalDuration: calculateTotalDuration(flowReportItems.map((report) => report.payload)),
                           totalNodes: new Set(flowReportItems.map((report) => report.payload.componentKey)).size
                        }
                     }
                  ]
               }
            }
         };
      }
      case ADD_REPORT_STATE: {
         const flowReport = state.flowReports[payload.flowId];

         if (!flowReport) return state;

         return {
            ...state,
            flowReports: {
               ...state.flowReports,
               [payload.flowId]: {
                  ...flowReport,
                  state: payload.state
               }
            }
         };
      }
      case RESET_EXECUTION_REPORTS:
         return {
            ...state,
            flowReports: {},
            executionReports: [],
            executionBatchDateTime: ""
         };
      case SET_EXECUTOR_SOCKET_DOWN:
         return {
            ...state,
            isExecutorSocketDown: payload
         };
   }

   return state;
};

export default flowExecution;
